import type { DateRange } from "@quortex/front-common"

export const filterWidth = "max-w-62 min-w-40" as const

export const dateRangeToString = (dateRange: DateRange | null) =>
  dateRange && {
    endDate: dateRange.endDate.toISOString(),
    startDate: dateRange.startDate.toISOString()
  }

/**
 * A MultiSelectionProvider filter value has to be a scalar or an array, so a range is flattened to a
 * single-member array. Setting or moving the range then reads as a narrowing and clears the
 * selection, which is the safe outcome: a moved range can hide a selected row. With no range, an
 * empty array (rather than an empty string, which the library would still count as one member) makes
 * the library skip the facet entirely, so clearing the date filter never clears the selection.
 */
export const dateRangeToFilterValue = (dateRange: DateRange | null): string[] =>
  dateRange ? [`${dateRange.startDate.toISOString()}_${dateRange.endDate.toISOString()}`] : []

export const getDateRangeFromSearchAndStore = <
  Search extends { dateRange?: { startDate?: string; endDate?: string } },
  Store extends { dateRange?: { startDate: string; endDate: string } | null }
>(
  search: Search,
  store: Store
) => {
  return search.dateRange?.startDate && search.dateRange?.endDate
    ? {
        endDate: new Date(search.dateRange.endDate),
        startDate: new Date(search.dateRange.startDate)
      }
    : store.dateRange
      ? {
          endDate: new Date(store.dateRange.endDate),
          startDate: new Date(store.dateRange.startDate)
        }
      : null
}

export const matchDateRange = (date: Date, dateRange: DateRange) =>
  dateRange.startDate.getTime() <= date.getTime() && date.getTime() <= dateRange.endDate.getTime()
